import * as React from 'react';
export const IcHairDresser = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.58 6.19a1 1 0 00-.9-.14l-4.22 1.41-.46 3.66a.999.999 0 01-.15.42l3.52-1A3.69 3.69 0 0022 7a1 1 0 00-.42-.81zm-8.8 9.06l.27-2.65 1.4-.71a1 1 0 00.54-.77l1-8A1 1 0 0015 2a3.19 3.19 0 00-3.19 2.89l-.6 5.91-2.77.81A3.49 3.49 0 109 13.53l2-.59-.21 2.13a3.52 3.52 0 102 .18h-.01zM5.5 15a1.5 1.5 0 110-2.999A1.5 1.5 0 015.5 15zm6 5a1.5 1.5 0 110-2.999 1.5 1.5 0 010 2.999z'
      fill='currentColor'
    />
  </svg>
);
